import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { InfoTooltip } from 'components';


const ValidationResults = ({
  results,
  data,
  resetFileData,
  proceedNext,
  customerGroups = [],
  existingCustomersEmails = new Set(),
  emailIndex = -1
}) => {
  const errorRows = Object.keys(results).length;
  const hasGroupInvalidError = Object.values(results).some((r) => (r as {groupError?: string}).groupError === 'Group is invalid, it should match one of the available store groups');
  const errorRowsInfo = Object.keys(results).map((r) => Number(r) + 1).join(', ');
  const totalRows = data.length;
  const validRows = totalRows - errorRows;
  const existingRows = data.filter((row, index) => (
    !results[index] && existingCustomersEmails.has(row[emailIndex]?.trim().toLowerCase())
  )).length;

  return (
    <div className="mx-10 my-5">
      {errorRows ?
        <p className="font-bold">
          <span className="text-error">Validation failed. </span>
          <span>The CSV file contains errors. Please fix the errors and try again.</span>
        </p>
        :
        <p className="font-bold text-green">Validation Passed successfully.</p>
      }
      <Grid container spacing={1} className="mt-5 mb-6">
        <Grid item xs={6} md={4} lg={2}>
          Total Customers in File:
        </Grid>
        <Grid item xs={6} md={8} lg={10}>
          {totalRows}
        </Grid>
        <Grid item xs={6} md={4} lg={2} className="text-green">
          Successfully Validated:
        </Grid>
        <Grid item xs={6} md={8} lg={10} className="text-green">
          {validRows}
        </Grid>
        {!!existingRows &&
        <>
          <Grid item xs={6} md={4} lg={2} className="text-orange">
            {'Existing Customers (will be updated):'}
          </Grid>
          <Grid item xs={6} md={8} lg={10} className="text-orange">
            {existingRows}
          </Grid>
        </>
        }
        {!!errorRows &&
        <>
          <Grid item xs={6} md={4} lg={2} className="text-error">
            {'Needs to be Fixed:'}
            <InfoTooltip
              classNames="text-error text-15"
              title={`Errors in rows: ${errorRowsInfo}`}
            />
          </Grid>
          <Grid item xs={6} md={8} lg={10} className="text-error align-start">
            {errorRows}
          </Grid>
        </>
        }
      </Grid>
      <div>
        <div className="mb-2">
          <strong className="uppercase">Note:</strong>
        </div>
        <div>
          <div className="mb-1">
            {'Default value will be configured if field '}
            <strong>Gender</strong>
            {' (Female or Male) is empty in CSV file for import'}
          </div>
          <div className="mb-4">
            {'Default value will be configured if field '}
            <strong>Date Of Birth</strong>
            {' (mm/dd/yyyy) is empty in CSV file for import'}
          </div>
          {hasGroupInvalidError && !!customerGroups.length &&
            <div className="mb-4">
              {'Available store groups: '}
              <strong>{customerGroups.filter((g) => !g.code.toLowerCase().includes('promotool')).map((g) => g.code).join(', ')}</strong>
            </div>
          }
          {!!existingRows &&
            <div className="mb-4 text-orange">
              {`${existingRows} customer(s) already exist in the store and will be updated instead of created. `}
              {'The following attributes will be updated: '}
              <strong>Phone, Date Of Birth, Gender, Group</strong>
            </div>
          }
        </div>
        <div className="mb-1">
          {`PROCEED: Import your ${validRows} valid records. The ${errorRows} records with issues will be ignored and won\`t be imported.`}
        </div>
        <div>
          {'CANCEL: Correct the issues and try again. No records will be imported until the issues are fixed and the CSV file is re-uploaded.'}
        </div>
      </div>
      <div className="flex items-center justify-between my-10">
        <Button
          variant="outlined"
          className="uppercase w-160 font-bold"
          onClick={resetFileData}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          className="uppercase w-160 font-bold"
          onClick={proceedNext}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default ValidationResults;
